import React from 'react';
var CaretLeft = function (_a) {
    var width = _a.width, height = _a.height, opacity = _a.opacity, fill = _a.fill;
    return (React.createElement("svg", { width: width, height: height, opacity: opacity, viewBox: "0 0 30 30" },
        React.createElement("polygon", { fill: fill, points: "20.55 0 24.453519 3.90351896 13.3573737 15 24.453519 26.096481 20.55 30 5.55 15" })));
};
export default CaretLeft;
